import Swiper from "swiper";
import { Navigation, Pagination, Thumbs, FreeMode } from "swiper/modules";

const initialize = () => {
  const thumbSwiper = new Swiper(".gd-top-weekly-picks-images .gd-thumb-swiper", {
    modules: [FreeMode, Thumbs],
    spaceBetween: 16,
    slidesPerView: 3,
    freeMode: true,
    watchSlidesProgress: true,
  });
  const swiper = new Swiper(".gd-top-weekly-picks-images .gd-swiper", {
    modules: [Navigation, Pagination, Thumbs],
    // loop: true,
    navigation: {
      nextEl: ".gd-top-weekly-picks-images .gd-swiper .swiper-button-next",
      prevEl: ".gd-top-weekly-picks-images .gd-swiper .swiper-button-prev",
    },
    pagination: {
      el: ".gd-top-weekly-picks-images .gd-swiper .swiper-pagination",
      clickable: true,
    },
    thumbs: {
      swiper: thumbSwiper,
    },
  });
};

document.addEventListener("DOMContentLoaded", () => {
  if (window.gd.template != "index" || !window.gd.sections) {
    return;
  }
  const sectionData = window.gd.sections.find((s) => s.type == "top-weekly-picks");
  if (!sectionData) {
    return;
  }
  initialize(sectionData);
});
